import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/tmp/26d35be0/src/layouts/work.js"
import Video from '../../components/Video'

export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={props}
             components={components}>


<Video id="Mcnp8l2TPBs" />
<MDXTag name="p" components={components}>{`Katapult Future Fest is an output-driven festival in Oslo, Norway, focusing on how exponential technologies and impact investing can create a thriving future society for all. We designed the visual identity and website for the 2018-festival.`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="img" components={components} parentName="p" props={{"src":"/work/katapult/kff-front@2x.png","alt":"Katapult Future Fest mobile screens"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/katapult/kff-screens@2x.png","alt":"Katapult Future Fest desktop screens"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/katapult/kff-pattern@2x.png","alt":"Katapult Future Fest logo mark"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/katapult/kff-mobile-screens@2x.png","alt":"Katapult Future Fest selected screens"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/katapult/kff-photos@2x.png","alt":"Katapult Future Fest selected screens"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/katapult/kff-long-screens@2x.png","alt":"Katapult Future Fest selected screens"}}></MDXTag></MDXTag>
           </MDXTag>
  }
}

export const _frontmatter = {};

  